module.exports = __webpack_public_path__ + "f40f7682ab435bef7080a73feba14bec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/fortinet_2022_chart.png
// module id = 1679
// module chunks = 0